
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function MainContentRT () {
    return _createElement('div', {
        'id': 'itemsBlock',
        'className': 'cm_SearchPage'
    }, [this.SearchVehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          - Select ', this.title, ' -\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, '...loading...') : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title',
                                        'disabled': true,
                                        'key': '10931'
                                    }, 'Popular ', this.title === 'Make' ? 'Makes' : this.title === 'Model' ? 'Models' : 'Values'),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title',
                                        'disabled': true,
                                        'key': '10934'
                                    }, 'Additional ', this.title === 'Make' ? 'Makes' : this.title === 'Model' ? 'Models' : 'Values')
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                '- Select ',
                                this.title,
                                ' -'
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3439'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3641'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                            'key': '39'
                        }, _createElement('select', {
                            'className': 'cm_select_inner-select cm_form-select form-select form-select--small',
                            'onChange': this.onChange,
                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                'aria-label': this.title,
                                'key': '2738'
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n      - Select ', this.title, ' -\n    ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, '...loading...') : null,
                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                        ]) : null);
                    }, { count: undefined })];
            }
            return !this.isVehicleSelected ? _createElement('div', {
                'className': 'cm_vehicle-widget cm_vehicle-widget__search cm_SearchVehicleWidget',
                'key': '0'
            }, this.template === 'active' ? _createElement('div', {
                'className': 'cm_vehicle-widget_dropdowns cmTemplate_active',
                'key': '112'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, 'Shop by Vehicle'), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go button',
                'onClick': this.selectVehicle,
                'disabled': !this.allowToSetVehicle,
                'role': 'button',
                'tabIndex': this.allowToSetVehicle ? '0' : '-1'
            }, '\n    Search Products\n  '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear button button--secondary',
                'onClick': this.discardVehicle,
                'disabled': !this.allowToDiscardVehicle,
                'role': 'button',
                'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
            }, [_createElement('svg', {
                    'className': 'cm_icon cm_icon-times',
                    'height': '20px',
                    'role': 'img',
                    'viewBox': '0 0 22 22',
                    'key': '68670'
                }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))], ' Clear all\n  ')))) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'cm_vehicle-widget_label cmTemplate_locked',
                'key': '7056'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, '\n  ', this.vehicleString, '\n  ', _createElement('span', { 'className': 'cm_vehicle-widget_subtitle' }, this.fitmentSearchTitle), [this.facetToggle(function () {
                    return _createElement('div', { 'className': 'cm_facetToggle' }, _createElement('span', {
                        'className': 'cm_facet-toggle_label',
                        'onClick': this.toggleFacet
                    }, '\n  Show Universal Parts\n'), _createElement('label', { 'className': 'cm_facet-toggle_switch' }, _createElement('input', {
                        'className': 'cm_facet-toggle_input',
                        'type': 'checkbox',
                        'checked': this.isToggled,
                        'onChange': this.toggleFacet
                    }), _createElement('span', { 'className': 'cm_facet-toggle_slider' })));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget__change button',
                'onClick': this.changeVehicle,
                'role': 'button',
                'tabIndex': '0'
            }, '\n      Change Vehicle\n    '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget__discard button button--secondary',
                'onClick': this.discardVehicle,
                'role': 'button',
                'tabIndex': '0'
            }, [_createElement('svg', {
                    'className': 'cm_icon cm_icon-times',
                    'height': '20px',
                    'role': 'img',
                    'viewBox': '0 0 22 22',
                    'key': '85220'
                }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))], ' Clear all\n    ')))) : null) : null;
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.CategoryPageCategoriesCarousel(function () {
            function repeatHierarchicalGroups1(hierarchicalGroups, hierarchicalGroupsIndex) {
                return [hierarchicalGroups(function () {
                        return _createElement('div', { 'className': 'cm_vehicle-categories_category-wrapper' }, _createElement('a', {
                            'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link',
                            'href': this.href
                        }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, _createElement('img', {
                            'className': 'cm_vehicle-categories_category-image',
                            'src': this.getImageOrDefault(this.imageUrl),
                            'alt': this.value
                        })), _createElement('div', { 'className': 'cm_vehicle-categories_category-title-container cm_vehicle-categories_link' }, _createElement('h5', { 'className': 'cm_vehicle-categories_category-title' }, this.value))));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_CategoryPageCategoriesCarousel' }, _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__subcategories cm_vehicle-categories__flat' }, _createElement.apply(this, [
                'div',
                {
                    'className': 'cm_vehicle-categories_category-wrapper-repeater  cmRepeater_hierarchicalGroups',
                    'data-cm-scroll-container': this.view === 'carousel'
                },
                _map(this.hierarchicalGroups, repeatHierarchicalGroups1.bind(this))
            ]), this.hierarchicalGroups?.length && this.view === 'carousel' ? [
                _createElement('button', {
                    'type': 'button',
                    'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_left',
                    'onClick': this.scrollLeft,
                    'disabled': this.isLeftBorder,
                    'data-cm-scroll-left': true,
                    'key': '13731'
                }),
                _createElement('button', {
                    'type': 'button',
                    'className': 'cm_vehicle-categories_category-scroll-button cm_vehicle-categories_category-scroll-button_right',
                    'onClick': this.scrollRight,
                    'disabled': this.isRightBorder,
                    'data-cm-scroll-right': true,
                    'key': '13733'
                })
            ] : null));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], _createElement('div', { 'className': 'cm_SearchHeader__container' }, [this.SearchVehicleWidget_label(function () {
            return _createElement('div', { 'className': 'cm_vehicle-widget__label cm_SearchVehicleWidget_label' }, _createElement('div', { 'className': 'cm_vehicle-widget__label-title' }, 'Your Vehicle:'), _createElement('div', { 'className': 'cm_vehicle-widget__label-button_container' }, _createElement('button', {
                'className': 'cm_vehicle-widget__label-button' + (this.isVehicleSelected ? ' selected' : ''),
                'onClick': this.openDialog
            }, this.isVehicleSelected ? _createElement('img', {
                'height': '20px',
                'width': '20px',
                'src': 'https://cdn11.bigcommerce.com/s-tkhuby6608/images/stencil/original/image-manager/jeep-icon-white.png',
                'key': '333'
            }) : null, '\n    ', this.isVehicleSelected ? `${ this.vehicleString }` : 'Add your vehicle', '\n  '), this.isVehicleSelected ? _createElement('div', {
                'className': 'cm_vehicle-widget__label-clear',
                'onClick': this.discardVehicle,
                'key': '610'
            }, [_createElement('svg', {
                    'className': 'cm_icon-trash',
                    'width': '20',
                    'height': '20',
                    'viewBox': '0 0 20 20',
                    'fill': 'none',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'key': '7220'
                }, _createElement('path', {
                    'd': 'M15 7.5L14.3 14.4983C14.1942 15.5592 14.1417 16.0892 13.9 16.49C13.688 16.8428 13.3763 17.125 13.0042 17.3008C12.5817 17.5 12.05 17.5 10.9833 17.5H9.01667C7.95083 17.5 7.41833 17.5 6.99583 17.3C6.62337 17.1243 6.31134 16.8421 6.09917 16.4892C5.85917 16.0892 5.80583 15.5592 5.69917 14.4983L5 7.5M11.25 12.9167V8.75M8.75 12.9167V8.75M3.75 5.41667H7.59583M7.59583 5.41667L7.9175 3.19C8.01083 2.785 8.3475 2.5 8.73417 2.5H11.2658C11.6525 2.5 11.9883 2.785 12.0825 3.19L12.4042 5.41667M7.59583 5.41667H12.4042M12.4042 5.41667H16.25',
                    'stroke': 'black',
                    'strokeLinecap': 'round',
                    'strokeLinejoin': 'round'
                }))]) : null));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchHeader(function () {
            return _createElement('div', { 'className': 'cm_SearchHeader' }, _createElement('div', { 'className': 'cm_sort sort-by' }, _createElement('span', { 'className': 'sort-label' }, 'Sort by'), '\n  ', this.sortSelect, '\n'), [this.facetDialogButton(function () {
                    return _createElement('div', { 'className': 'cm_facetDialogButton' }, [this.dialogButton(function () {
                            return _createElement('div', { 'className': 'button--grey button--small button cm_dialogButton' }, '\n  Filters ', [_createElement('svg', {
                                    'className': 'cm_icon cm_filter-icon',
                                    'viewBox': '0 0 15 15',
                                    'key': '740'
                                }, _createElement('path', {
                                    'd': 'M14 7.5H5.318m0 0c0 .427-.162.837-.45 1.14a1.494 1.494 0 0 1-1.082.472c-.407 0-.796-.17-1.084-.472a1.657 1.657 0 0 1-.448-1.14m3.064 0c0-.428-.162-.838-.45-1.14a1.494 1.494 0 0 0-1.082-.473c-.407 0-.796.17-1.084.472a1.657 1.657 0 0 0-.448 1.14m0 0H1m13 4.888H9.96m0 0c0 .428-.16.838-.448 1.14A1.494 1.494 0 0 1 8.428 14c-.406 0-.796-.17-1.083-.473a1.657 1.657 0 0 1-.449-1.14m3.065 0c0-.428-.162-.838-.45-1.14a1.495 1.495 0 0 0-1.083-.473c-.406 0-.796.17-1.083.473a1.657 1.657 0 0 0-.449 1.14m0 0H1m13-9.774h-2.182m0 0c0 .211-.04.421-.117.617a1.62 1.62 0 0 1-.332.523c-.143.15-.311.268-.497.35a1.465 1.465 0 0 1-.586.122c-.407 0-.796-.17-1.084-.472a1.657 1.657 0 0 1-.448-1.14m3.064 0c0-.212-.04-.422-.117-.618a1.62 1.62 0 0 0-.332-.523 1.528 1.528 0 0 0-.497-.35A1.465 1.465 0 0 0 10.286 1c-.407 0-.796.17-1.084.472a1.657 1.657 0 0 0-.448 1.14m0 0H1',
                                    'stroke': 'currentColor',
                                    'strokeMiterlimit': '10',
                                    'strokeLinecap': 'round'
                                }))]);
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'search-header',
            items: undefined
        })]), [this.FilterChips(function () {
            return _createElement('div', { 'className': 'cm_filterChips cm_filterChips__search-header cm_FilterChips' }, [this.filterChips(function () {
                    function repeatChips1(chips, chipsIndex) {
                        return [chips(function () {
                                function repeatI1_reviewChip(i, iIndex) {
                                    return _createElement('span', {
                                        'key': `${ this.field }|${ i }`,
                                        'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                    });
                                }
                                function scopeInchMm1_rangeChip() {
                                    var inch = [].includes(this.field) ? '"' : '';
                                    var mm = [
                                        'wheel_bore',
                                        'wheel_offset'
                                    ].includes(this.field) ? 'mm' : '';
                                    return _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? _createElement(_Fragment, { 'key': '365' }, this.selectedRange[0], inch, mm, ' to ', this.selectedRange[1], inch, mm) : null, this.toPosInf ? _createElement(_Fragment, { 'key': '491' }, this.selectedRange[0], inch, mm, ' and more') : null, this.toNegInf ? _createElement(_Fragment, { 'key': '591' }, this.selectedRange[1], inch, mm, ' and less') : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                            'className': 'cm_icon cm_icon-times',
                                            'height': '20px',
                                            'role': 'img',
                                            'viewBox': '0 0 22 22',
                                            'key': '7210'
                                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                                }
                                return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? 'search within' : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '2570'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                    'a',
                                    {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    },
                                    _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                    _map([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ], repeatI1_reviewChip.bind(this)),
                                    this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '4900'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? scopeInchMm1_rangeChip.apply(this, []) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                        'className': 'facettitle',
                        'tabIndex': '0'
                    }, 'Current search:'), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                        'div',
                        {
                            'role': 'list',
                            'className': 'cmRepeater_chips'
                        },
                        _map(this.chips, repeatChips1.bind(this))
                    ]), _createElement('div', {
                        'className': 'button--clear button button--secondary cm_filter-chips_button',
                        'data-cm-role': 'start-over'
                    }, [_createElement('svg', {
                            'className': 'cm_icon cm_icon-times',
                            'height': '20px',
                            'role': 'img',
                            'viewBox': '0 0 22 22',
                            'key': '49330'
                        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))], ' Clear all\n      '))));
                }, {
                    widgetName: 'filter-chips',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.message(function () {
            return _createElement('div', { 'className': 'cm_message' }, this.hasMessage('TrialExpired') ? [_createElement('div', { 'key': '240' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                    'href': 'mailto:support@convermax.com',
                    'className': 'cm_message-link'
                }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.hasMessage('AggressiveWheels') ? [_createElement('div', { 'key': '4980' }, '\n  Warning: Aggressive wheel options are displayed, but we cannot guarantee they will fit your selected\n  vehicle.\n')] : null, this.hasMessage('IncompatibleParts') && !this.notFilteredByVehicle ? [_createElement('div', {
                    'className': 'cm_message__incompatible',
                    'key': '7050'
                }, _createElement('div', {}, '\n    The products shown below will not fit a ', _createElement('span', {}, this.vehicleString), '.', _createElement('br', {}), '\n    The products results are based on your keyword search only.\n  '))] : null, this.isNoVehicleSpecificResults && this.isVehicleSelected && !this.notFilteredByVehicle && !this.hasMessage('NonVehicleProducts') ? [_createElement('div', {
                    'className': 'cm_message__universal',
                    'key': '10350'
                }, '\n  The system was unable to find any vehicle specific products that fit a\n  ', _createElement('span', {}, '\'', this.vehicleString, '\'.'), _createElement('br', {}), '\n  Click ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'href': this.searchByVehicleUrl
                }, 'here'), ' to clear your vehicle\n  selection and browse all products in the category.\n')] : null, this.template === 'badRequest' ? _createElement('div', {
                'className': 'cmTemplate_badRequest',
                'key': '1568'
            }, 'Your request failed to process (', _createElement('b', {}, 'status:'), ' ', this.error.status, ', ', _createElement('b', {}, 'id:'), ' ', this.error.userId, ',\n', _createElement('b', {}, 'timestamp:'), ' ', this.error.timestamp, ', ', _createElement('b', {}, 'instance:'), ' ', this.error.instance, ').\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.startOver
            }, 'clear your search'), ' and try\nsearching for something else.\n') : null, this.template === 'corrected' ? _createElement('div', {
                'className': 'cmTemplate_corrected',
                'key': '1982'
            }, 'Your search for ', _createElement('span', { 'className': 'query' }, this.originalQuery), '\ndid not match any products. The system searched for\n', _createElement('span', { 'className': 'query' }, this.query), ' instead.\n') : null, this.template === 'networkError' ? _createElement('div', {
                'className': 'cmTemplate_networkError',
                'key': '2236'
            }, 'Network error\n', this.error ? [
                '(id: ',
                this.error.userId,
                ', timestamp: ',
                this.error.timestamp,
                ', instance: ',
                this.error.instance,
                ')'
            ] : null, '.\n', _createElement('br', {}), '\nThe search server could not be reached. Please try again later.\n') : null, this.template === 'nothing' ? _createElement('div', {
                'className': 'cmTemplate_nothing',
                'key': '2554'
            }, _createElement('div', {}, _createElement('div', { 'className': 'cm_message-title' }, 'We can\'t find products matching the selection.'), this.query || !!this.vehicleString && !this.notFilteredByVehicle ? [
                '\n    Click ',
                _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'onClick': this.startOver,
                    'key': '27301'
                }, 'here'),
                ' to clear\n    ',
                !this.vehicleString ? [' selection. '] : null,
                this.vehicleString && (!this.isFacetsSelected || !this.notFilteredByVehicle) ? ['\n      all keyword searches, filter selections, and vehicle selections to again browse all products.\n    '] : null
            ] : null)) : null, this.template === 'timeout' ? _createElement('div', {
                'className': 'cmTemplate_timeout',
                'key': '3249'
            }, 'Your search request timed out.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, 'try your search again'), '.\n') : null, this.template === 'partial' ? _createElement('div', {
                'className': 'cmTemplate_partial',
                'key': '3468'
            }, 'The system was unable to find products to match your entire search of\n', _createElement('span', { 'className': 'query' }, this.originalQuery), '. A partial search was performed instead.\n') : null, this.template === 'unknown' ? _createElement('div', {
                'className': 'cmTemplate_unknown',
                'key': '3712'
            }, 'Your search request failed to process\n', this.error ? [
                '\n  (',
                this.error.status ? [
                    _createElement('b', { 'key': '38630' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '39500' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '40330' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '38284' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null, '.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, 'try your search again'), '.\n') : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.customMessage(function () {
            return _createElement('div', { 'className': 'cm_message cm_customMessage' }, []);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchResult(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('li', {}, _createElement('article', {
                            'className': 'card',
                            'data-event-type': 'list',
                            'data-name': this.removeHTML(this.name),
                            'data-product-brand': this.removeHTML(this.brand_name),
                            'data-product-price': this.price
                        }, _createElement('form', {
                            'className': 'card-inner',
                            'method': 'post',
                            'action': '/cart.php',
                            'encType': 'multipart/form-data'
                        }, _createElement('figure', { 'className': 'card-figure' }, !this.out_of_stock && this.on_sale ? _createElement('div', {
                            'className': 'product-badge product-badge--sale',
                            'key': '320'
                        }, _createElement('span', { 'className': 'product-badge__text body-xs' }, 'On Sale!')) : null, !this.on_sale && this.out_of_stock ? _createElement('div', {
                            'className': 'product-badge product-badge--sold-out',
                            'key': '510'
                        }, _createElement('span', { 'className': 'product-badge__text body-xs' }, 'Out of Stock')) : null, _createElement('a', {
                            'href': this.custom_url,
                            'className': 'card-figure__link',
                            'aria-label': this.removeHTML(this.name),
                            'data-event-type': 'product-click'
                        }, _createElement('div', { 'className': 'card-img-container' }, _createElement('img', {
                            'src': this.imageOrDefault(this.images_image_standard1),
                            'alt': this.removeHTML(this.name),
                            'title': this.removeHTML(this.name),
                            'data-sizes': 'auto',
                            'className': 'card-image lazyautosizes ls-is-cached lazyloaded',
                            'sizes': '424px',
                            'onError': this.onImageError
                        }), _createElement('img', {
                            'src': this.imageOrDefault(this.images_image_standard2),
                            'alt': this.removeHTML(this.name),
                            'title': this.removeHTML(this.name),
                            'data-sizes': 'auto',
                            'className': 'card-image card-image--hover lazyautosizes ls-is-cached lazyloaded',
                            'sizes': '424px',
                            'onError': e => this.onImageError(e, 'images_image_standard2')
                        }))), _createElement('div', { 'className': 'add-to-cart-wrapper add-to-cart-wrapper--desktop' }, _createElement('div', { 'className': 'add-to-cart-inner' }, _createElement('div', { 'className': 'add-to-cart-buttons' }, _createElement('div', { 'className': 'form-action' }, !this.has_options && !this.out_of_stock ? _createElement('input', {
                            'id': 'form-action-addToCart',
                            'className': 'button button--primary',
                            'type': 'submit',
                            'data-can-purchase': 'true',
                            'value': 'Add to Cart',
                            'key': '1724'
                        }) : null))))), _createElement('div', { 'className': 'card-body text-center text-common-white' }, _createElement('h3', { 'className': 'card-title' }, _createElement('a', Object.assign({}, {
                            'aria-label': this.removeHTML(this.name),
                            'href': this.custom_url,
                            'data-event-type': 'product-click'
                        }, { dangerouslySetInnerHTML: { __html: this.name } }))), this.Function ? _createElement('p', {
                            'className': 'card-excerpt body-sm',
                            'key': '2281'
                        }, this.Function) : null, _createElement('p', { 'className': 'card-options-count body-sm js-options-count' }), _createElement('div', {
                            'className': 'card-text card-price-wrapper',
                            'data-test-info-type': 'price'
                        }, this.retail_price > this.price ? _createElement('div', {
                            'className': 'price-section price-section--withoutTax rrp-price--withoutTax',
                            'key': '2509'
                        }, _createElement('span', { 'className': 'price price--rrp' }, this.formatPrice(this.retail_price))) : null, this.on_sale ? _createElement('div', {
                            'className': 'price-section price-section--withoutTax non-sale-price--withoutTax',
                            'key': '2742'
                        }, _createElement('span', { 'className': 'price price--non-sale' }, this.formatPrice(this.regular_price))) : null, _createElement('div', { 'className': 'price-section price-section--withoutTax price--withoutTax' }, this.has_options && !this.on_sale ? _createElement('span', {
                            'className': 'price-label',
                            'key': '3049'
                        }, 'Starting at ') : null, _createElement('span', { 'className': 'price' }, this.formatPrice(this.price)))), _createElement('div', { 'className': 'add-to-cart-wrapper add-to-cart-wrapper--mobile' }, _createElement('div', { 'className': 'add-to-cart-inner' }, _createElement('div', { 'className': 'add-to-cart-buttons' }, _createElement('div', { 'className': 'form-action' }, !this.has_options && !this.out_of_stock ? _createElement('input', {
                            'id': 'form-action-addToCart',
                            'className': 'button button--primary',
                            'type': 'submit',
                            'data-can-purchase': 'true',
                            'value': 'Add to Cart',
                            'key': '3461'
                        }) : null, this.has_options ? _createElement('a', {
                            'href': this.custom_url,
                            'data-event-type': 'product-click',
                            'className': 'button card-figcaption-button',
                            'data-product-id': this.id,
                            'key': '3659'
                        }, '\n                  Shop Now\n                ') : null))))))));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_SearchResult' }, _createElement('div', { 'className': 'hero-title heading-h2' }, window.Convermax.categoryTitle), _createElement.apply(this, [
                'ul',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.message(function () {
                    return _createElement('div', { 'className': 'cm_message' }, this.hasMessage('TrialExpired') ? [_createElement('div', { 'key': '240' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                            'href': 'mailto:support@convermax.com',
                            'className': 'cm_message-link'
                        }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.hasMessage('AggressiveWheels') ? [_createElement('div', { 'key': '4980' }, '\n  Warning: Aggressive wheel options are displayed, but we cannot guarantee they will fit your selected\n  vehicle.\n')] : null, this.hasMessage('IncompatibleParts') && !this.notFilteredByVehicle ? [_createElement('div', {
                            'className': 'cm_message__incompatible',
                            'key': '7050'
                        }, _createElement('div', {}, '\n    The products shown below will not fit a ', _createElement('span', {}, this.vehicleString), '.', _createElement('br', {}), '\n    The products results are based on your keyword search only.\n  '))] : null, this.isNoVehicleSpecificResults && this.isVehicleSelected && !this.notFilteredByVehicle && !this.hasMessage('NonVehicleProducts') ? [_createElement('div', {
                            'className': 'cm_message__universal',
                            'key': '10350'
                        }, '\n  The system was unable to find any vehicle specific products that fit a\n  ', _createElement('span', {}, '\'', this.vehicleString, '\'.'), _createElement('br', {}), '\n  Click ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'href': this.searchByVehicleUrl
                        }, 'here'), ' to clear your vehicle\n  selection and browse all products in the category.\n')] : null, this.template === 'badRequest' ? _createElement('div', {
                        'className': 'cmTemplate_badRequest',
                        'key': '1568'
                    }, 'Your request failed to process (', _createElement('b', {}, 'status:'), ' ', this.error.status, ', ', _createElement('b', {}, 'id:'), ' ', this.error.userId, ',\n', _createElement('b', {}, 'timestamp:'), ' ', this.error.timestamp, ', ', _createElement('b', {}, 'instance:'), ' ', this.error.instance, ').\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.startOver
                    }, 'clear your search'), ' and try\nsearching for something else.\n') : null, this.template === 'corrected' ? _createElement('div', {
                        'className': 'cmTemplate_corrected',
                        'key': '1982'
                    }, 'Your search for ', _createElement('span', { 'className': 'query' }, this.originalQuery), '\ndid not match any products. The system searched for\n', _createElement('span', { 'className': 'query' }, this.query), ' instead.\n') : null, this.template === 'networkError' ? _createElement('div', {
                        'className': 'cmTemplate_networkError',
                        'key': '2236'
                    }, 'Network error\n', this.error ? [
                        '(id: ',
                        this.error.userId,
                        ', timestamp: ',
                        this.error.timestamp,
                        ', instance: ',
                        this.error.instance,
                        ')'
                    ] : null, '.\n', _createElement('br', {}), '\nThe search server could not be reached. Please try again later.\n') : null, this.template === 'nothing' ? _createElement('div', {
                        'className': 'cmTemplate_nothing',
                        'key': '2554'
                    }, _createElement('div', {}, _createElement('div', { 'className': 'cm_message-title' }, 'We can\'t find products matching the selection.'), this.query || !!this.vehicleString && !this.notFilteredByVehicle ? [
                        '\n    Click ',
                        _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'onClick': this.startOver,
                            'key': '27301'
                        }, 'here'),
                        ' to clear\n    ',
                        !this.vehicleString ? [' selection. '] : null,
                        this.vehicleString && (!this.isFacetsSelected || !this.notFilteredByVehicle) ? ['\n      all keyword searches, filter selections, and vehicle selections to again browse all products.\n    '] : null
                    ] : null)) : null, this.template === 'timeout' ? _createElement('div', {
                        'className': 'cmTemplate_timeout',
                        'key': '3249'
                    }, 'Your search request timed out.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, 'try your search again'), '.\n') : null, this.template === 'partial' ? _createElement('div', {
                        'className': 'cmTemplate_partial',
                        'key': '3468'
                    }, 'The system was unable to find products to match your entire search of\n', _createElement('span', { 'className': 'query' }, this.originalQuery), '. A partial search was performed instead.\n') : null, this.template === 'unknown' ? _createElement('div', {
                        'className': 'cmTemplate_unknown',
                        'key': '3712'
                    }, 'Your search request failed to process\n', this.error ? [
                        '\n  (',
                        this.error.status ? [
                            _createElement('b', { 'key': '38630' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '39500' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '40330' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '38284' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null, '.\n', _createElement('br', {}), '\nPlease ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, 'try your search again'), '.\n') : null);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'results',
            items: undefined
        })], [this.pagination(function () {
            function repeatButtons1(buttons, buttonsIndex) {
                return [buttons(function () {
                        return this.template === 'prev' ? _createElement('li', {
                            'className': 'pagination-item pagination-item--previous cmTemplate_prev',
                            'href': this.pageLink
                        }, _createElement('a', {
                            'className': 'pagination-link',
                            'href': this.pageLink,
                            'data-faceted-search-facet': true,
                            'aria-label': 'Previous'
                        }, _createElement('button', {
                            'type': true,
                            'className': 'button button--grey button--icon'
                        }, _createElement('span', { 'className': 'button__wrapper' }, _createElement('span', { 'className': 'icon icon--arrow-left button__leading-icon' }, _createElement('span', { 'className': 'visually-hidden' }, 'arrow-left'), _createElement('svg', { 'viewBox': '0 0 17 15' }, _createElement('path', {
                            'd': 'M7 1 1 7.5 7 14M1 7.5h16',
                            'stroke': 'currentColor',
                            'fill': 'transparent'
                        }))))))) : this.template === 'next' ? _createElement('li', {
                            'className': 'pagination-item pagination-item--next cmTemplate_next',
                            'href': this.pageLink
                        }, _createElement('a', {
                            'className': 'pagination-link',
                            'href': this.pageLink,
                            'data-faceted-search-facet': true,
                            'aria-label': 'Next'
                        }, _createElement('button', {
                            'type': true,
                            'className': 'button button--grey button--icon'
                        }, _createElement('span', { 'className': 'button__wrapper' }, _createElement('span', { 'className': 'icon icon--arrow button__leading-icon' }, _createElement('span', { 'className': 'visually-hidden' }, 'arrow'), _createElement('svg', { 'viewBox': '0 0 17 15' }, _createElement('path', {
                            'd': 'm10 1 6 6.5-6 6.5M16 7.5H0',
                            'stroke': 'currentColor',
                            'fill': 'transparent'
                        }))))))) : this.template === 'delimiter' ? _createElement('li', { 'className': 'pagination-item pagination-item--delimiter no-js cmTemplate_delimiter' }, '...') : this.template === 'page' ? _createElement('li', {
                            'className': 'pagination-item' + (this.isActive ? ' pagination-item--current' : '') + ' cmTemplate_page',
                            'href': this.pageLink
                        }, _createElement('a', {
                            'href': this.pageLink,
                            'className': 'pagination-link'
                        }, this.page)) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                    }, { count: undefined })];
            }
            return _createElement('nav', { 'className': 'pagination cm_pagination' }, _createElement.apply(this, [
                'ul',
                { 'className': 'pagination-list cmRepeater_buttons' },
                _map(this.buttons, repeatButtons1.bind(this))
            ]));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:filterInput","cm:facetToggle","cm:SearchVehicleWidget","cm:CategoryPageCategoriesCarousel","cm:SearchVehicleWidget_label","cm:dialogButton","cm:facetDialogButton","cm:SearchHeader","cm:filterChips","cm:FilterChips","cm:message","cm:customMessage","cm:message","cm:SearchResult","cm:pagination"]